module.exports = __webpack_public_path__ + "img/image5.b187d913.png";